import Layout from '@/components/layout/Layout';

const GDPR = () => {
  return (
    <Layout
      title="GDPR | Lux Decor by Kamen"
      description="Informacije o GDPR skladnosti in obdelavi osebnih podatkov v podjetju Lux Decor by Kamen."
    >
      <section className="py-16 bg-luxbeige">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-semibold mb-6">GDPR Politika</h1>
            <div className="h-1 w-24 bg-luxgold mb-10"></div>
            
            <div className="lux-card space-y-6">
              <section>
                <h2 className="text-2xl font-medium mb-4">1. Uvod v GDPR</h2>
                <p className="text-luxgray">
                  Splošna uredba o varstvu podatkov (GDPR) je uredba Evropske unije, ki je začela veljati 25. maja 2018 in določa pravila 
                  o varstvu posameznikov pri obdelavi osebnih podatkov in pravila o prostem pretoku osebnih podatkov.
                </p>
                <p className="text-luxgray mt-2">
                  KAMEN d.o.o. spoštuje vašo zasebnost in se zavezuje k varovanju vaših osebnih podatkov v skladu z GDPR in drugimi veljavnimi predpisi o varstvu podatkov.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">2. Upravljavec podatkov</h2>
                <p className="text-luxgray">
                  Upravljavec vaših osebnih podatkov je:
                </p>
                <p className="text-luxgray mt-2">
                  KAMEN d.o.o.<br />
                  Levarska ulica 3<br />
                  2314 Zgornja Polskava<br />
                  Slovenija<br />
                  E-pošta: info@luxdecor.si<br />
                  Telefon: +386 31 467 272
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">3. Pravna podlaga za obdelavo</h2>
                <p className="text-luxgray">
                  Vaše osebne podatke obdelujemo na naslednjih pravnih podlagah:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li><strong>Izpolnitev pogodbe:</strong> obdelava je potrebna za izpolnitev pogodbe, katere pogodbena stranka ste, ali za izvajanje ukrepov na vašo zahtevo pred sklenitvijo pogodbe (npr. obdelava naročila).</li>
                  <li><strong>Zakonska obveznost:</strong> obdelava je potrebna za izpolnitev zakonske obveznosti, ki velja za nas (npr. hranjenje računov za davčne namene).</li>
                  <li><strong>Zakoniti interes:</strong> obdelava je potrebna zaradi zakonitih interesov, za katere si prizadevamo mi ali tretja oseba (npr. za preprečevanje goljufij).</li>
                  <li><strong>Privolitev:</strong> dali ste privolitev za obdelavo svojih osebnih podatkov za enega ali več določenih namenov (npr. za pošiljanje e-novic).</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">4. Nameni obdelave</h2>
                <p className="text-luxgray">
                  Vaše osebne podatke obdelujemo za naslednje namene:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Za obdelavo in dostavo vaših naročil</li>
                  <li>Za komunikacijo z vami glede vaših naročil, izdelkov ali storitev</li>
                  <li>Za izpolnjevanje naših zakonskih obveznosti</li>
                  <li>Za izboljšanje naše spletne strani, izdelkov in storitev</li>
                  <li>Za pošiljanje promocijskih sporočil, če ste v to privolili</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">5. Kategorije osebnih podatkov</h2>
                <p className="text-luxgray">
                  Obdelujemo naslednje kategorije osebnih podatkov:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Identifikacijski podatki (ime, priimek)</li>
                  <li>Kontaktni podatki (e-poštni naslov, telefonska številka, naslov)</li>
                  <li>Podatki o transakcijah (podatki o kupljenih izdelkih, datum nakupa, znesek)</li>
                  <li>Tehnični podatki (IP naslov, podatki o brskalniku)</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">6. Prejemniki osebnih podatkov</h2>
                <p className="text-luxgray">
                  Vaše osebne podatke lahko delimo z naslednjimi kategorijami prejemnikov:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Ponudniki storitev, ki nam pomagajo pri poslovanju (npr. dostavne službe, ponudniki plačilnih storitev, gostovanje spletne strani)</li>
                  <li>Državni organi, če to zahteva zakon</li>
                </ul>
                <p className="text-luxgray mt-2">
                  Z vsemi zunanjimi ponudniki storitev imamo sklenjene ustrezne pogodbe o obdelavi podatkov, ki zagotavljajo, da vaše osebne podatke obdelujejo v skladu z GDPR.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">7. Obdobje hrambe</h2>
                <p className="text-luxgray">
                  Vaše osebne podatke hranimo le toliko časa, kot je potrebno za namene, za katere smo jih zbrali, ali kot to zahteva zakon:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Podatke o naročilih in računih hranimo 10 let zaradi davčnih predpisov</li>
                  <li>Podatke za namene neposrednega trženja hranimo do preklica vaše privolitve</li>
                  <li>Podatke za podporo strankam hranimo 2 leti po zadnji komunikaciji</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">8. Vaše pravice</h2>
                <p className="text-luxgray">
                  V skladu z GDPR imate naslednje pravice:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li><strong>Pravica do dostopa:</strong> imate pravico zahtevati informacije o osebnih podatkih, ki jih hranimo o vas.</li>
                  <li><strong>Pravica do popravka:</strong> imate pravico zahtevati popravek netočnih osebnih podatkov, ki jih hranimo o vas.</li>
                  <li><strong>Pravica do izbrisa ("pravica do pozabe"):</strong> imate pravico zahtevati izbris vaših osebnih podatkov v določenih okoliščinah.</li>
                  <li><strong>Pravica do omejitve obdelave:</strong> imate pravico zahtevati omejitev obdelave vaših osebnih podatkov v določenih okoliščinah.</li>
                  <li><strong>Pravica do prenosljivosti podatkov:</strong> imate pravico prejeti osebne podatke, ki ste nam jih posredovali, v strukturirani, splošno uporabljani in strojno berljivi obliki.</li>
                  <li><strong>Pravica do ugovora:</strong> imate pravico ugovarjati obdelavi vaših osebnih podatkov v določenih okoliščinah.</li>
                  <li><strong>Pravica do umika privolitve:</strong> če obdelava temelji na privolitvi, imate pravico kadar koli umakniti svojo privolitev.</li>
                </ul>
                <p className="text-luxgray mt-2">
                  Za uveljavljanje katerekoli od teh pravic nas kontaktirajte na info@luxdecor.si. Na vašo zahtevo bomo odgovorili v enem mesecu.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">9. Pravica do pritožbe pri nadzornem organu</h2>
                <p className="text-luxgray">
                  Če menite, da obdelava vaših osebnih podatkov krši GDPR, imate pravico vložiti pritožbo pri Informacijskem pooblaščencu Republike Slovenije:
                </p>
                <p className="text-luxgray mt-2">
                  Informacijski pooblaščenec<br />
                  Dunajska cesta 22<br />
                  1000 Ljubljana<br />
                  Telefon: 01 230 97 30<br />
                  E-pošta: gp.ip@ip-rs.si
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">10. Kontakt</h2>
                <p className="text-luxgray">
                  Za vsa vprašanja ali zahteve v zvezi z obdelavo vaših osebnih podatkov nas kontaktirajte na:
                </p>
                <p className="text-luxgray mt-2">
                  KAMEN d.o.o.<br />
                  E-pošta: info@luxdecor.si<br />
                  Telefon: +386 31 467 272
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default GDPR;